export default {"src":"/_next/static/media/socialicon-linkedin.bc3c7a50.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};